exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-e0b4a5dc] {\n  text-decoration: none;\n}\n.list-box-status[data-v-e0b4a5dc] {\n  -webkit-box-align: normal;\n      -ms-flex-align: normal;\n          align-items: normal;\n}\n.list-box-header[data-v-e0b4a5dc] {\n  min-height: 66px;\n}\n.role-roles[data-v-e0b4a5dc] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.full-name[data-v-e0b4a5dc] {\n  font-weight: 500;\n  font-size: 16px;\n  color: #4c5669;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e0b4a5dc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/SettingsPhoneNumbersBlock.vue
// module id = WzV+
// module chunks = 0